import { Box } from '@mui/material';
import { getTenderDetails } from 'lib/api/publicMarket';
import TableWithPagination, {
  Header,
} from 'lib/designSystem/TableWithPagination';
import { errorHandler } from 'lib/functions/errors';
import { Tender } from 'lib/types/models';
import { Pagination } from 'lib/types/shared';
import React from 'react';
import { useDispatch } from 'react-redux';
import { showTenderModal } from 'services/redux/tenderModalSlice';

export interface TendersProps {
  loading: boolean;
  fetchData: (params?: { page: number; pageSize: number }) => Promise<{
    data: Tender[];
    pagination: Pagination;
  } | void>;
  data: Tender[];
  setData: (data: Tender[]) => void;
  pagination: Pagination;
  setPagination: (pagination: Pagination) => void;
}

const Tenders: React.FC<TendersProps> = ({
  loading,
  fetchData,
  data,
  setData,
  pagination,
  setPagination,
}) => {
  const dispatch = useDispatch();

  const headers: Header[] = [
    {
      label: 'Código',
      key: 'externalCode',
      customComponent: (value: string) => <Box sx={{ py: 1 }}>{value}</Box>,
    },
    { label: 'Nombre', key: 'name' },
    { label: 'Tipo', key: 'type' },
    { label: 'Estado', key: 'status' },
    { label: 'Mandante', key: 'buyerId' },
    { label: 'Fecha Publicación', key: 'publicationDate', type: 'date' },
    { label: 'Fecha Cierre', key: 'closeDate', type: 'date' },
    { label: 'Fecha Adjudicación', key: 'adjudicationDate', type: 'date' },
    { label: 'Monto Estimado', key: 'estimatedAmount', type: 'money' },
  ];

  const handleRowClick = async (rowId: string) => {
    try {
      if (!rowId) throw new Error('Tender ID is required');
      const tenderDetails = await getTenderDetails(dispatch, rowId);
      if (tenderDetails) dispatch(showTenderModal(tenderDetails));
    } catch (error) {
      errorHandler(dispatch, error);
    }
  };

  return (
    <Box sx={{ py: 2 }}>
      <TableWithPagination
        data={data}
        setData={setData}
        dataHeaders={headers}
        loading={loading}
        handleClickRow={handleRowClick}
        pagination={pagination}
        setPagination={setPagination}
        searchData={fetchData}
        exportToFile="xlsx"
      />
    </Box>
  );
};

export default Tenders;
